import { ActivitySpinnerWidget } from '@tableau/widgets';
import React, { ReactElement } from 'react';
import { connect } from 'react-redux';

import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { MapStateToProps } from '~src/commonInfra/utils/ConnectUtils';
import { IGetSiteEncryptionKeyDataKey } from '~src/settings/security-settings/sections/credential-encryption/models/CredentialEncryptionModels';

import { cellStyle, headerStyle, rowStyle, tableStyle } from '../styles/CredentialEncryptionSettingsStyles';
import { capitalizeFirstLetter, formatDate, getTooltip } from '../utils/CredentialEncrpytionUtils';
import { KMSEncryptionKeyActionMenu } from './KMSEncrpytionKeyActionMenu';

export interface KMSEncryptionKeyTableOwnProps {
}

export interface KMSEncryptionKeyTableStateProps {
  isLoading: boolean;
  kmsKeys: IGetSiteEncryptionKeyDataKey[];
}

export type KMSEncryptionKeyTableProps = KMSEncryptionKeyTableOwnProps & KMSEncryptionKeyTableStateProps;


interface ColumnKey {
  name: string;
  width: string;
  render: (key: IGetSiteEncryptionKeyDataKey) => ReactElement;
}

export function getColumnKeys(): ColumnKey[]{
  return [
    {
      name: Messages.credentialEncryptionKMS_Version_Header(),
      width: '20%',
      render: (key: IGetSiteEncryptionKeyDataKey) => getTooltip(key.keyVersionId)
    },
    {
      name: Messages.actions(),
      width: '5%',
      render: (key: IGetSiteEncryptionKeyDataKey) => <KMSEncryptionKeyActionMenu kmsEncrpytionKey={key} />
    },
    {
      name: Messages.credentialEncryptionKMS_KeyMaterialSource_Header(),
      width: '10%',
      render: (key: IGetSiteEncryptionKeyDataKey) => getTooltip(key.keyMaterialSource)
    },
    {
      name: Messages.credentialEncryptionKMS_Status_Header(),
      width: '10%',
      render: (key: IGetSiteEncryptionKeyDataKey) => getTooltip(capitalizeFirstLetter(key.status))
    },
    {
      name: Messages.credentialEncryptionKMS_RootKey_Header(),
      width: '20%',
      render: (key: IGetSiteEncryptionKeyDataKey) => getTooltip(key.rootKeyId)
    },
    {
      name: Messages.credentialEncryptionKMS_Generated_Header(),
      width: '10%',
      render: (key: IGetSiteEncryptionKeyDataKey) => getTooltip(formatDate(key.keyCreatedDate))
    },
    {
      name: Messages.credentialEncryptionKMS_Modified_Header(),
      width: '10%',
      render: (key: IGetSiteEncryptionKeyDataKey) => getTooltip(formatDate(key.keyModifiedDate))
    }
  ];
  }

export class KMSEncryptionKeyTableComponent extends React.PureComponent<KMSEncryptionKeyTableProps, {}> {

  public constructor(props: KMSEncryptionKeyTableProps) {
    super(props);
  }

  public render() {
    if(this.props.isLoading){
      return(
        <div style={{paddingRight: '50px'}}>
          <table style={tableStyle}>
            {this.getTableHeaders()}
          </table>
            <div data-tb-test-id style={{textAlign: 'center'}}>
              <ActivitySpinnerWidget style={{textAlign:'center', marginTop: '30px'}} testId='test'></ActivitySpinnerWidget>
            </div>
        </div>
      );
    } else{
      return (
        <div style={{paddingRight: '50px'}}>
          <table style={tableStyle}>
            {this.getTableHeaders()}
            <tbody>
              {this.props.kmsKeys.map((key, index) => (
                <React.Fragment key={index}>
                  <tr style={rowStyle}>
                    {getColumnKeys().map((header, headerIndex) => (
                      <td key={headerIndex} style={{ ...cellStyle, width: header.width }}>
                      {header.render(key)}
                    </td>
                    ))}
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }

  private getTableHeaders() {
      return (
        <thead>
          <tr style={rowStyle}>
            {getColumnKeys().map((header, index) => (
              <th key={index} style={{ ...headerStyle, width: header.width }}>
                {getTooltip(header.name)}
              </th>
            ))}
          </tr>
        </thead>
      );
    }
 }

const mapStateToProps: MapStateToProps<KMSEncryptionKeyTableStateProps> = (state: AppState) => ({
  isLoading: state.credentialEncryptionInfo.isFetchingEncryptionKey,
  kmsKeys: state.credentialEncryptionInfo.encryptionKey?.dataKeys ?? []
});

export const KMSEncryptionKeyTable: React.ComponentClass<KMSEncryptionKeyTableOwnProps> =
  connect(mapStateToProps, undefined)(KMSEncryptionKeyTableComponent);